import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVehicleSecurity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7379 14.996L16.1072 14.2517C16.0516 14.227 16.0046 14.1864 15.972 14.135L14.5589 11.8824C14.2957 11.4623 13.8333 11.2089 13.3375 11.2131H7.59498C7.14664 11.2118 6.72325 11.4192 6.44959 11.7743L4.63229 14.1551C4.59164 14.2095 4.53408 14.2489 4.4686 14.267L1.43136 15.0981C0.997601 15.2189 0.698608 15.6153 0.701648 16.0655V17.1762C0.701648 17.7292 1.13381 18.189 1.68682 18.189H1.9514C2.02938 17.1615 2.846 16.3449 3.87354 16.2669C5.02228 16.1797 6.02421 17.0403 6.11139 18.189H12.6881C12.7661 17.1615 13.5828 16.3449 14.6103 16.2669C15.759 16.1797 16.761 17.0403 16.8481 18.189H17.3318C17.8848 18.189 18.317 17.7292 18.317 17.1762V15.9083C18.3201 15.5168 18.0935 15.1598 17.7379 14.996Z",
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0284 14.3466L16.5007 13.649L15.1523 11.4977C14.7626 10.8742 14.0767 10.4961 13.3401 10.5H7.59564C6.92922 10.5 6.29788 10.8079 5.89257 11.3379L4.15052 13.6178L1.2471 14.4128C0.510533 14.6155 0 15.2897 0 16.0535V17.1642C0 18.1035 0.748262 18.879 1.68749 18.879H1.93691C2.23699 20.0365 3.41784 20.7302 4.57531 20.4301C5.33527 20.2313 5.93154 19.639 6.1264 18.879H12.6737C12.9738 20.0365 14.1546 20.7302 15.3121 20.4301C16.0721 20.2313 16.6683 19.639 16.8632 18.879H17.3309C18.2701 18.879 19.0183 18.1035 19.0183 17.1642V15.8977C19.0222 15.2312 18.6325 14.6233 18.0284 14.3466ZM4.0297 19.713C3.26585 19.713 2.6462 19.0934 2.6462 18.3295C2.6462 17.5657 3.26585 16.946 4.0297 16.946C4.79356 16.946 5.41321 17.5657 5.41321 18.3295C5.41711 19.0895 4.79745 19.7091 4.0297 19.713ZM14.7665 19.713C14.0026 19.713 13.383 19.0934 13.383 18.3295C13.383 17.5657 14.0026 16.946 14.7665 16.946C15.5303 16.946 16.15 17.5657 16.15 18.3295C16.1539 19.0895 15.5342 19.7091 14.7665 19.713ZM17.3309 18.0996H16.9177C16.7891 16.9109 15.7174 16.0535 14.5288 16.186C13.5194 16.2952 12.7244 17.0941 12.6152 18.0996H6.18096C6.05235 16.9109 4.98062 16.0535 3.79198 16.186C2.7826 16.2952 1.98757 17.0941 1.87845 18.0996H1.68359C1.17306 18.0996 0.775543 17.6748 0.775543 17.1642V16.0535C0.771646 15.6365 1.04835 15.2741 1.44976 15.1611L4.48568 14.331C4.56752 14.3076 4.64157 14.2608 4.69223 14.1907L6.50832 11.8095C6.76944 11.4743 7.17085 11.2795 7.59564 11.2795H13.3401C13.8078 11.2756 14.2482 11.5133 14.4937 11.9108L15.9045 14.1634C15.9434 14.2297 16.0058 14.2803 16.0721 14.3115L17.7011 15.0559C18.0284 15.2078 18.2389 15.5352 18.235 15.8977V17.1642H18.2389C18.2389 17.6748 17.8414 18.0996 17.3309 18.0996Z",
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.03119 16.8744C3.22315 16.8744 2.5681 17.5294 2.5681 18.3375C2.5681 19.1455 3.22315 19.8006 4.03119 19.8006C4.83885 19.7997 5.49338 19.1451 5.49428 18.3375C5.49428 17.5294 4.83924 16.8744 4.03119 16.8744Z",
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7681 16.8744C13.9601 16.8744 13.305 17.5294 13.305 18.3375C13.305 19.1455 13.9601 19.8006 14.7681 19.8006C15.5757 19.7997 16.2303 19.1451 16.2312 18.3375C16.2312 17.5294 15.5761 16.8744 14.7681 16.8744Z",
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_201_43)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M21.9167 6.08333H16.0833C15.6231 6.08333 15.25 6.45643 15.25 6.91667V9.83333C15.25 10.2936 15.6231 10.6667 16.0833 10.6667H21.9167C22.3769 10.6667 22.75 10.2936 22.75 9.83333V6.91667C22.75 6.45643 22.3769 6.08333 21.9167 6.08333Z",
				fill: "#DBE4E8",
				stroke: "#293235",
				strokeWidth: .75,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M16.9167 6.08333V4.41666C16.9167 3.86413 17.1361 3.33422 17.5268 2.94352C17.9175 2.55282 18.4475 2.33333 19 2.33333C19.5525 2.33333 20.0824 2.55282 20.4731 2.94352C20.8638 3.33422 21.0833 3.86413 21.0833 4.41666V6.08333",
				stroke: "#293235",
				strokeWidth: .75,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_201_43",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 10,
				height: 10,
				fill: "white",
				transform: "translate(14 1.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgVehicleSecurity);
export { ForwardRef as ReactComponent };
